import { render, staticRenderFns } from "./newPageHezuo.vue?vue&type=template&id=696e42f3&scoped=true"
import script from "./newPageHezuo.vue?vue&type=script&lang=js"
export * from "./newPageHezuo.vue?vue&type=script&lang=js"
import style0 from "./newPageHezuo.vue?vue&type=style&index=0&id=696e42f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696e42f3",
  null
  
)

export default component.exports